import React from 'react';

import { permissions } from '@vlabs/shared/config';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { generatePath } from 'react-router-dom';

import { viewerCan } from '@vlabs/pages/auth/selectors';
import { selectHandlerOptions } from '@vlabs/pages/handlers/selectors';

const HandlerLink = ({
  handlerId,
  handlerOptions,
  can,
  hideId,
  ...props
}) => {
  const { t } = useTranslation();
  if (!handlerId) return null;

  const handlerLabel = handlerOptions?.find((handler) => handler.value === handlerId)?.label;

  if (!handlerLabel && can([permissions.handler.view]) && hideId) return t('удалён');
  if (!handlerLabel && !can([permissions.handler.view]) && hideId) return t('недоступно');
  if (!handlerLabel && !hideId) return handlerId;

  return (
    <Control.Link
      data-testid={`HandlerLink-${handlerId}`}
      to={generatePath(routes.handlers.read, { handlerId })}
      {...props}
    >
      {handlerLabel}
    </Control.Link>
  );
};

HandlerLink.propTypes = {
  handlerId: PropTypes.string,
  handlerOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  can: PropTypes.func.isRequired,
  hideId: PropTypes.bool,
  size: PropTypes.string,
};
HandlerLink.defaultProps = {
  handlerId: undefined,
  handlerOptions: [],
  hideId: false,
  size: 'large',
};

export default connect(
  (state) => ({
    handlerOptions: selectHandlerOptions(state),
    can: viewerCan(state),
  }),
)(HandlerLink);
